import type { FaireProductEntity } from "../../entity_types/product";

export const p_n6sb39sh5y: FaireProductEntity = {
  token: "p_n6sb39sh5y",
  type: "product",
  name: "Set of 2 White Medium stoneware ceramic Pet Bowls — Party Collection",
  brandToken: "b_5ja2cf4hvd",
  brandName: "Egg Back Home USA",
  imageUrl:
    "https://cdn.faire.com/fastly/6aeaeb79a95184365eaf4e3c499ca7ae44a3d75f2348e91bbbcf5e146b29965d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/43af9bc47abd859db51186c7d0fe026171ed5bbca6b7402e523c30d1feeb1c8f.jpeg",
    "https://cdn.faire.com/fastly/b836a37cd48b02cc2e16d9145993e5d97ea0d2f6d02000e23f76e311bfb818af.jpeg",
    "https://cdn.faire.com/fastly/c57e0c87d3e7c00a796ec4783c477a55e2b2aa6667906392bd4704cb2b5fd8eb.jpeg",
  ],
  priceDollars: 20,
  description:
    'Introducing our lovely "New Party Pet Bowl"! The option from the "New Party Collection" that was missing to your best friend, so your entire home could enjoy the vibrant and lively aesthetic of this collection, full of love :)\n\n\n\nDimensions:\n\nDiameter: 5,51 in\nHeight: 1,96 in\n\n\nAll our pieces are:\n\nDishwasher and microwave safe.\nFood safe.\nCadmium Free.\nMaterial: Stoneware with less than 3% absorption.\n\nOur Party Collection features a special type of glaze that may exhibit areas where speckles become diffused due to the glass\'s reactive nature during processing. We find these unique, unpredictable variations to be the most beautiful aspect of the glaze.\n\nCrafted with meticulous care, each Party Serving Bowl is a testament to our commitment to producing unique and exceptional tableware. Our artisanal process ensures that no two pieces are exactly alike, celebrating individuality. Please note that glaze colors may slightly vary due to production techniques. If you have any queries or seek more information, please don\'t hesitate to reach out to us.\n',
  tags: [],
  msrpDollars: 40,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:19.870Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
